import React, { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import TopInsightDetails from './TopInsightDetails';
import { ObjectMap } from 'mf_core/query';

type Props = {
  maxDropHeight?: number;
  topInsightsData: Array<ObjectMap>;
};

export default function CategoryInsightsDetails(props: Props) {
  const { maxDropHeight, topInsightsData } = props;
  const offsetHeight = 245;
  const [maxHeight, setMaxHeight] = useState(window.innerHeight - offsetHeight);

  useEffect(() => {
    setMaxHeight(window.innerHeight - offsetHeight);

    const handleWindowResize = () => {
      setMaxHeight(window.innerHeight - offsetHeight);
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return (
    <StyledCategoryWrapperStack
      spacing={2.5}
      sx={{
        maxHeight: maxDropHeight ? maxDropHeight + 60 : maxHeight,
        width: '100%',
      }}
    >
      {topInsightsData?.map((insightData: ObjectMap, index) => {
        return (
          <TopInsightDetails insightData={insightData} key={index ?? ''} />
        );
      })}
    </StyledCategoryWrapperStack>
  );
}

const StyledCategoryWrapperStack = styled(Stack)(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '8.86px',
    width: '8.86px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: theme.palette.text.disabled,
    borderRadius: '6px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: theme.palette.primary.main,
  },
  '&::-webkit-scrollbar-track': {
    borderRadius: '6px',
    boxShadow: 'none',
  },
  '&::-webkit-scrollbar-track:hover': {
    boxShadow: 'inset 0 0 6px #C4C4C4',
  },
  marginTop: theme.spacing(2),
  maxHeight: 335,
  overflowY: 'auto',
}));
